import { AuthService } from '@/services'
import { Avatar } from '@/components'
import { Vue, Component } from 'vue-property-decorator'
import {
	VBtn,
	VDivider,
	VIcon,
	VList,
	VListItem,
	VListItemContent,
	VListItemIcon,
	VListItemSubtitle,
	VListItemTitle,
	VMenu
} from 'vuetify/lib'
import Icons from '@/assets/icons'
import ROUTERS from '@/router/ROUTERS'
import { AuthFlowHelper } from '@/utils'

@Component({})
export class UserMenu extends Vue {
	isNewAuthFlowEnabled: boolean = false

	get userCompleteName() {
		const { state } = this.$store
		return state.user?.name
	}
	get userEmail() {
		const { state } = this.$store
		return state.user?.email
	}
	get userAvatar() {
		const { state } = this.$store
		return state.user?.pathAvatar
	}

	get user() {
		const { state } = this.$store
		return state.user
	}

	get shouldShowUserSelect() {
		const hasMoreThenOneAccount = this.$store.state.userAccounts.length > 1
		return hasMoreThenOneAccount && this.isNewAuthFlowEnabled
	}

	async mounted() {
		this.isNewAuthFlowEnabled = await AuthFlowHelper.isNewAuthFlowEnabled()
	}

	async logout() {
		await AuthService.logout()
	}

	toggleTheme() {
		this.$vuetify.theme.dark = !this.$vuetify.theme.dark
	}

	accountUrl() {
		return import.meta.env.VUE_APP_API_AUTH_HOST
	}

	public render() {
		return (
			<VMenu
				tile
				{...{ attrs: this.$attrs }}
				offset-y
				scopedSlots={{
					activator: ({ on }: { on: any }) => (
						<VBtn icon style="border: none" text tile outlined on={on}>
							<Avatar style="margin-top: -4px" size={28} userId={this.user.id} />
						</VBtn>
					)
				}}
			>
				<VList>
					<div class="pa-6 text-center">
						<Avatar userId={this.user.id} />

						<div class="text-center my-4">
							<VListItemTitle class="text-center font-weight-bold">{this.userCompleteName}</VListItemTitle>
							<VListItemSubtitle class="font-weight-medium ">{this.userEmail || '-'}</VListItemSubtitle>
						</div>
					</div>

					<VDivider />

					<VListItem onClick={() => this.openEditAvatarModal()}>
						<VListItemIcon>
							<VIcon>mdi-account-circle-outline</VIcon>
						</VListItemIcon>
						<VListItemContent>
							<VListItemTitle>Meu avatar</VListItemTitle>
							<VListItemSubtitle class="font-weight-medium ">Personalize do seu jeito</VListItemSubtitle>
						</VListItemContent>
					</VListItem>

					<VDivider />

					{this.shouldShowUserSelect && (
						<VListItem onClick={() => this.$router.push({ name: ROUTERS.ACCOUNT.SELECT_USER })}>
							<VListItemIcon>
								<VIcon>{Icons.People}</VIcon>
							</VListItemIcon>
							<VListItemContent>
								<VListItemTitle>Selecionar conta</VListItemTitle>
							</VListItemContent>
						</VListItem>
					)}

					<VDivider />
					<div class="pa-4 text-center">
						<VBtn tile block onClick={this.logout} outlined color="red">
							<VIcon>mdi-logout</VIcon>
							Deslogar
						</VBtn>
					</div>
				</VList>
			</VMenu>
		)
	}

	openEditAvatarModal() {
		this.$root.$emit('dialog:openAvatarEdit')
	}
}

export default UserMenu
